/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_GeneratingInputs */

const en_cover_letters_generating = /** @type {(inputs: Cover_Letters_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating...`)
};

const de_cover_letters_generating = /** @type {(inputs: Cover_Letters_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird generiert...`)
};

const fr_cover_letters_generating = /** @type {(inputs: Cover_Letters_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génération en cours...`)
};

const es_cover_letters_generating = /** @type {(inputs: Cover_Letters_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando...`)
};

const it_cover_letters_generating = /** @type {(inputs: Cover_Letters_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione...`)
};

const nl_cover_letters_generating = /** @type {(inputs: Cover_Letters_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereren...`)
};

const pl_cover_letters_generating = /** @type {(inputs: Cover_Letters_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generowanie...`)
};

const fi_cover_letters_generating = /** @type {(inputs: Cover_Letters_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luodaan...`)
};

const da_cover_letters_generating = /** @type {(inputs: Cover_Letters_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genererer...`)
};

const sv_cover_letters_generating = /** @type {(inputs: Cover_Letters_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genererar...`)
};

/**
* | output |
* | --- |
* | "Generating..." |
*
* @param {Cover_Letters_GeneratingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_generating = /** @type {((inputs?: Cover_Letters_GeneratingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_GeneratingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_generating(inputs)
	if (locale === "fr") return fr_cover_letters_generating(inputs)
	if (locale === "es") return es_cover_letters_generating(inputs)
	if (locale === "it") return it_cover_letters_generating(inputs)
	if (locale === "nl") return nl_cover_letters_generating(inputs)
	if (locale === "pl") return pl_cover_letters_generating(inputs)
	if (locale === "fi") return fi_cover_letters_generating(inputs)
	if (locale === "da") return da_cover_letters_generating(inputs)
	if (locale === "sv") return sv_cover_letters_generating(inputs)
	return en_cover_letters_generating(inputs)
});